<div class="apenas--mobile">
  <div class="container-principal__header">
    <dynamic-form [fields]="regLabelMenuCacauLover"></dynamic-form>
  </div>
</div>
<div class="apenas--desktop">
  <div class="container-principal__header header--desktop">
    <img
      class="header__voltar"
      src="assets/images/icons/voltar.png"
      (click)="voltarPaginaAnterior()"
    />

    <label class="cs_label header__titulo">Meus Pedidos</label>
  </div>
</div>

<div class="conteudo__carregando" *ngIf="carregandoPedidos">
  <app-only-loader></app-only-loader>
  <p class="cs_label">Carregando pedidos</p>
</div>

<div class="container-principal__conteudo">
  <!-- <div class="justify-content-center divPecaDeNovo" [hidden]="!pedidos">
        <dynamic-form [fields]="regUltimoPedido"></dynamic-form>
    </div> -->
  <div>
    <div [ngClass]="{ 'filtro--disabled': carregandoPedidos }">
      <div class="row d-flex justify-content-center" style="text-align: center">
        <dynamic-form [fields]="regHistoricoFiltro"></dynamic-form>
      </div>
      <div class="carousel__produtos">
        <dynamic-form [fields]="regConfigCarousel"></dynamic-form>
      </div>
    </div>
    <div class="historico_container" *ngIf="!carregandoPedidos">
      <dynamic-form [fields]="regConfigHistorico"></dynamic-form>
    </div>
  </div>

  <div
    class="sem_pedidos"
    *ngIf="pedidosSemFiltro.length == 0 && !carregandoPedidos"
  >
    <dynamic-form [fields]="regConfigSemDados"></dynamic-form>
  </div>
</div>
